import { render, staticRenderFns } from "./DesignExport.vue?vue&type=template&id=2889e33b&"
import script from "./DesignExport.vue?vue&type=script&lang=js&"
export * from "./DesignExport.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports